import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-start-now',
  templateUrl: './start-now.component.html',
  styleUrls: ['./start-now.component.scss']
})
export class StartNowComponent {
  constructor(
    private route: Router
  ) {}

  navigateTo(route: any[]) {
    this.route.navigate(route);
  }
}
